<script lang="ts">
  interface Props {
    size?: number;
    [key: string]: any;
  }

  let { size = 16, ...rest }: Props = $props();
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 16 16"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
  {...rest}
>
  <path
    d="M2.2047 5.05339C3.27912 2.94445 5.47088 1.5 8 1.5C11.5899 1.5 14.5 4.41015 14.5 8C14.5 11.5899 11.5899 14.5 8 14.5C4.41015 14.5 1.5 11.5899 1.5 8C1.5 7.84456 1.50546 7.69038 1.51619 7.53767"
    stroke="url(#paint0_radial_6579_15825)"
    stroke-width="1.5"
    stroke-linecap="round"
  />
  <mask
    id="mask0_6579_15825"
    style="mask-type:luminance"
    maskUnits="userSpaceOnUse"
    x="0"
    y="0"
    width="16"
    height="16"
  >
    <path
      d="M8 0.75C12.0041 0.75 15.25 3.99594 15.25 8C15.25 12.0041 12.0041 15.25 8 15.25C3.99594 15.25 0.75 12.0041 0.75 8C0.75 3.99594 3.99594 0.75 8 0.75Z"
      fill="white"
      style="fill:white;fill-opacity:1;"
    />
  </mask>
  <g mask="url(#mask0_6579_15825)">
    <path
      d="M5.1875 13.7813L8.25318 7.57544"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
    />
    <path
      d="M13.8162 10.8892C13.8162 10.8892 15.0408 8.70668 14.1945 5.9334C13.3247 3.08265 10.9417 2.28125 10.9417 2.28125C10.9417 2.28125 14.0466 3.87333 14.3709 7.39644C14.5688 9.54667 13.7361 10.8939 13.7361 10.8939C13.7361 10.8939 13.8062 10.8939 13.8162 10.8939C13.8262 10.8939 13.8162 10.8892 13.8162 10.8892Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M14.1945 6.03783C15.0312 8.81402 13.8162 10.889 13.8162 10.889C13.8162 10.889 13.8074 10.889 13.8162 10.8937C13.8162 10.8937 15.0312 8.81402 14.1945 6.03783ZM14.1945 6.03783C13.315 3.1195 10.9417 2.24243 10.9417 2.24243"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M10.5898 9.32259C10.5898 9.32259 11.0815 8.12189 11.2336 6.03783C11.4009 3.74357 10.961 2.24243 10.961 2.24243C10.961 2.24243 13.315 3.1195 14.1945 6.03783C15.0312 8.81402 13.8162 10.8937 13.8162 10.8937C13.8162 10.8937 13.3619 9.91497 12.4959 9.45004C11.6298 8.98511 10.5898 9.32259 10.5898 9.32259Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M5.52808 6.65076C5.52808 6.65076 6.07604 5.5077 7.27488 4.37822C8.88132 2.86473 10.99 2.23291 10.99 2.23291C10.99 2.23291 11.3295 3.51305 11.2336 5.7013C11.1405 7.82467 10.5898 9.32273 10.5898 9.32273C10.5898 9.32273 9.42385 7.57443 8.34937 7.1095C7.27488 6.64457 5.52808 6.65076 5.52808 6.65076Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
    <path
      d="M2.20209 5.07957C2.20209 5.07957 2.75039 3.66253 4.41167 2.57896C7.79865 0.369808 11.0479 2.26183 11.0479 2.26183C11.0479 2.26183 9.17267 2.69481 7.28966 4.43472C6.43466 5.22474 5.52807 6.65071 5.52807 6.65071C5.52807 6.65071 5.0432 5.79744 4.22877 5.36196C3.41434 4.92647 2.20209 5.07957 2.20209 5.07957Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linejoin="round"
    />
  </g>
  <defs>
    <radialGradient
      id="paint0_radial_6579_15825"
      cx="0"
      cy="0"
      r="1"
      gradientUnits="userSpaceOnUse"
      gradientTransform="translate(1.5 7.1145) scale(7.58392)"
    >
      <stop stop-color="currentColor" stop-opacity="0" />
      <stop offset="0.097819" stop-color="currentColor" stop-opacity="0" />
      <stop offset="0.547619" stop-color="currentColor" stop-opacity="1" />
      <stop offset="1" stop-color="currentColor" stop-opacity="1" />
    </radialGradient>
    <clipPath id="clip0_6579_15825">
      <rect width={size} height={size} fill="white" />
    </clipPath>
  </defs>
</svg>
